module.exports = __webpack_public_path__ + "static/media/senior-citizen-illustration.07c96937.svg";